export default __webpack_public_path__ + "static/steamTunnel-20768908f309a4dbae50c3cb314e6cc4.svg";